module.exports = __webpack_public_path__ + "img/person_tipping_hand.5d49effe.gif";